import { GraphQLClient } from 'graphql-request';
import { appEnv } from './env';

export function createGraphQLClient(token?: string | null): GraphQLClient {
  if (!token) {
    throw new Error('Missing IRIS token for GraphQL request.');
  }

  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`
  };

  return new GraphQLClient(appEnv.graphqlEndpoint, { headers });
}
